import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class NotifyService {

    private _subject: Subject<any>;
    observer: Observable<any>;

    constructor() {
        this._subject = new Subject<any>();
        this.observer = this._subject.asObservable()
    }

    notify(data) {
        this._subject.next(data);
    }
}